import getIcon from 'src/utils/getIcon';

import { Statistic } from 'src/types/components';

import RichText from 'components/BaseHelpers/RichText';
import Text from 'components/BaseHelpers/Text';

import AnimatedStat from '../AnimatedStat';

import styles from './InfographicCard.module.scss';

type InfographicCardProps = {
  statistic: Statistic;
  animate: boolean;
};

const InfographicCard = ({ statistic, animate }: InfographicCardProps): JSX.Element | null => {
  const { stat, icon, prefix, suffix, statLabelAbove, statLabelBelow, subHeader, description } =
    statistic;

  const hasSubStatCopy = !!subHeader || !!description;

  const Icon = icon && getIcon({ type: icon });

  return (
    <div className={styles.card}>
      <div className={styles.statCopy}>
        <Text tag="p" className={styles.label} field={statLabelAbove} />
        {Icon && <Icon className={styles.icon} />}
        {stat && (
          <p className={styles.stat}>
            {prefix && (
              <sup className={styles.superText}>
                <Text field={prefix} />
              </sup>
            )}
            {animate ? <AnimatedStat stat={stat} /> : <Text field={stat} />}
            {suffix && (
              <sup className={styles.superText}>
                <Text field={suffix} />
              </sup>
            )}
          </p>
        )}
        <Text tag="p" className={styles.label} field={statLabelBelow} />
      </div>
      {hasSubStatCopy && (
        <div className={styles.substatCopy}>
          {subHeader && <Text tag="h4" field={subHeader} className={styles.subheader} />}
          {!!description && (
            <RichText styleType="p3" field={description} className={styles.description} />
          )}
        </div>
      )}
    </div>
  );
};

export default InfographicCard;
